/* eslint-disable no-unused-vars */
import { PowerBIResponse } from 'models/powerbi';
import { ApiServiceBase } from './base/api-service-base';

const baseEndpoint = 'embedded';

export interface IPowerBIApiService {
	getPowerBIDataInsightsService(pageFromUrl:string | null): Promise<PowerBIResponse>;
	getPowerBICampaignsService(pageFromUrl:string | null): Promise<PowerBIResponse>;
	getPowerBIDashboardService(pageFromUrl:string | null): Promise<PowerBIResponse>;
	getPowerBIOpsInsightsService(pageFromUrl:string | null): Promise<PowerBIResponse>;
	getPowerBICXInsightsService(pageFromUrl:string | null): Promise<PowerBIResponse>;
	getPowerBIProfitInsightsService(pageFromUrl:string | null): Promise<PowerBIResponse>;
	getPowerBICRMInsightsService(pageFromUrl:string | null): Promise<PowerBIResponse>;
	getPowerBID2CDashboardService(pageFromUrl:string | null): Promise<PowerBIResponse>;
	getPowerBIRetailDashboardService(pageFromUrl:string | null): Promise<PowerBIResponse>;
	getPowerBIConversionInsightsService(pageFromUrl:string | null): Promise<PowerBIResponse>;
	getPowerBIProductInsightsService(pageFromUrl:string | null): Promise<PowerBIResponse>;
	getPowerBIAcquisitionService(pageFromUrl:string | null): Promise<PowerBIResponse>;
	getPowerBIRetentionService(pageFromUrl:string | null): Promise<PowerBIResponse>;
	getPowerBISubscriptionService(pageFromUrl:string | null): Promise<PowerBIResponse>;
	getPowerBICustomerService(pageFromUrl:string | null): Promise<PowerBIResponse>;
	getEmbeddedToken(pageName: string): Promise<PowerBIResponse>;
}

export class PowerBIApiService extends ApiServiceBase implements IPowerBIApiService {
	public async getPowerBIDataInsightsService(pageFromUrl: string | null | undefined): Promise<PowerBIResponse> {
	 	const hasValidParam = pageFromUrl !== null && pageFromUrl !== undefined && pageFromUrl.trim() !== '';
		const url = hasValidParam
			? `${baseEndpoint}/data-insights?urlparams=${encodeURIComponent(pageFromUrl)}`
			: `${baseEndpoint}/data-insights`;
			return await this.GetFromApi<any>(url);
	}

	public async getPowerBIDashboardService(pageFromUrl: string | null | undefined): Promise<PowerBIResponse> {
		const hasValidParam = pageFromUrl !== null && pageFromUrl !== undefined && pageFromUrl.trim() !== '';
		const url = hasValidParam
			? `${baseEndpoint}/dashboard?urlparams=${encodeURIComponent(pageFromUrl)}`
			: `${baseEndpoint}/dashboard`;

		return await this.GetFromApi<any>(url);
	}


	public async getPowerBICampaignsService(pageFromUrl: string | null | undefined): Promise<PowerBIResponse> {
		const hasValidParam = pageFromUrl !== null && pageFromUrl !== undefined && pageFromUrl.trim() !== '';
		const url = hasValidParam
			? `${baseEndpoint}/campaigns?urlparams=${encodeURIComponent(pageFromUrl)}`
			: `${baseEndpoint}/campaigns`;
			return await this.GetFromApi<any>(url);
	}

	public async getEmbeddedToken(pageName: string): Promise<PowerBIResponse> {
		return await this.GetFromApi<any>(`${baseEndpoint}/refresh-token/${pageName}`);
	}

	public async getPowerBIOpsInsightsService(pageFromUrl: string | null | undefined): Promise<PowerBIResponse> {
		const hasValidParam = pageFromUrl !== null && pageFromUrl !== undefined && pageFromUrl.trim() !== '';
		const url = hasValidParam
			? `${baseEndpoint}/ops-insights?urlparams=${encodeURIComponent(pageFromUrl)}`
			: `${baseEndpoint}/ops-insights`;
			return await this.GetFromApi<any>(url);
	}

	public async getPowerBICXInsightsService(pageFromUrl: string | null | undefined): Promise<PowerBIResponse> {
		const hasValidParam = pageFromUrl !== null && pageFromUrl !== undefined && pageFromUrl.trim() !== '';
		const url = hasValidParam
			? `${baseEndpoint}/cx-insights?urlparams=${encodeURIComponent(pageFromUrl)}`
			: `${baseEndpoint}/cx-insights`;
			return await this.GetFromApi<any>(url);
	}

	public async getPowerBIProfitInsightsService(pageFromUrl: string | null | undefined): Promise<PowerBIResponse> {
		const hasValidParam = pageFromUrl !== null && pageFromUrl !== undefined && pageFromUrl.trim() !== '';
		const url = hasValidParam
			? `${baseEndpoint}/profit-insights?urlparams=${encodeURIComponent(pageFromUrl)}`
			: `${baseEndpoint}/profit-insights`;
			return await this.GetFromApi<any>(url);
	}

	
	public async getPowerBICRMInsightsService(pageFromUrl: string | null | undefined): Promise<PowerBIResponse> {
		const hasValidParam = pageFromUrl !== null && pageFromUrl !== undefined && pageFromUrl.trim() !== '';
		const url = hasValidParam
			? `${baseEndpoint}/crm-insights?urlparams=${encodeURIComponent(pageFromUrl)}`
			: `${baseEndpoint}/crm-insights`;
			return await this.GetFromApi<any>(url);
	}

	public async getPowerBID2CDashboardService(pageFromUrl: string | null | undefined): Promise<PowerBIResponse> {
		const hasValidParam = pageFromUrl !== null && pageFromUrl !== undefined && pageFromUrl.trim() !== '';
		const url = hasValidParam
			? `${baseEndpoint}/d2c-dashboard?urlparams=${encodeURIComponent(pageFromUrl)}`
			: `${baseEndpoint}/d2c-dashboard`;
		return await this.GetFromApi<any>(url);
	}

	public async getPowerBIRetailDashboardService(pageFromUrl: string | null | undefined): Promise<PowerBIResponse> {
		const hasValidParam = pageFromUrl !== null && pageFromUrl !== undefined && pageFromUrl.trim() !== '';
		const url = hasValidParam
			? `${baseEndpoint}/retail-dashboard?urlparams=${encodeURIComponent(pageFromUrl)}`
			: `${baseEndpoint}/retail-dashboard`;
		return await this.GetFromApi<any>(url);
	}

	public async getPowerBIConversionInsightsService(pageFromUrl: string | null | undefined): Promise<PowerBIResponse> {
		const hasValidParam = pageFromUrl !== null && pageFromUrl !== undefined && pageFromUrl.trim() !== '';
		const url = hasValidParam
			? `${baseEndpoint}/conversion-insights?urlparams=${encodeURIComponent(pageFromUrl)}`
			: `${baseEndpoint}/conversion-insights`;
		return await this.GetFromApi<any>(url);
	}

	public async getPowerBIProductInsightsService(pageFromUrl: string | null | undefined): Promise<PowerBIResponse> {
		const hasValidParam = pageFromUrl !== null && pageFromUrl !== undefined && pageFromUrl.trim() !== '';
		const url = hasValidParam
			? `${baseEndpoint}/product-insights?urlparams=${encodeURIComponent(pageFromUrl)}`
			: `${baseEndpoint}/product-insights`;
		return await this.GetFromApi<any>(url);
	}

	public async getPowerBIAcquisitionService(pageFromUrl: string | null | undefined): Promise<PowerBIResponse> {
		const hasValidParam = pageFromUrl !== null && pageFromUrl !== undefined && pageFromUrl.trim() !== '';
		const url = hasValidParam
			? `${baseEndpoint}/acquisition?urlparams=${encodeURIComponent(pageFromUrl)}`
			: `${baseEndpoint}/acquisition`;
		return await this.GetFromApi<any>(url);
	}

	public async getPowerBIRetentionService(pageFromUrl: string | null | undefined): Promise<PowerBIResponse> {
		const hasValidParam = pageFromUrl !== null && pageFromUrl !== undefined && pageFromUrl.trim() !== '';
		const url = hasValidParam
			? `${baseEndpoint}/retention?urlparams=${encodeURIComponent(pageFromUrl)}`
			: `${baseEndpoint}/retention`;
		return await this.GetFromApi<any>(url);
	}

	public async getPowerBISubscriptionService(pageFromUrl: string | null | undefined): Promise<PowerBIResponse> {
		const hasValidParam = pageFromUrl !== null && pageFromUrl !== undefined && pageFromUrl.trim() !== '';
		const url = hasValidParam
			? `${baseEndpoint}/subscription?urlparams=${encodeURIComponent(pageFromUrl)}`
			: `${baseEndpoint}/subscription`;
		return await this.GetFromApi<any>(url);
	}

	public async getPowerBICustomerService(pageFromUrl: string | null | undefined): Promise<PowerBIResponse> {
		const hasValidParam = pageFromUrl !== null && pageFromUrl !== undefined && pageFromUrl.trim() !== '';
		const url = hasValidParam
			? `${baseEndpoint}/customer?urlparams=${encodeURIComponent(pageFromUrl)}`
			: `${baseEndpoint}/customer`;
		return await this.GetFromApi<any>(url);
	}
}
